import { createContext, useContext } from 'react';

interface DropdownGroupContextValue {
  setLabelId: (id: string | undefined) => void;
}

export const DropdownGroupContext =
  createContext<DropdownGroupContextValue | null>(null);

export const useDropdownGroupContext = () => useContext(DropdownGroupContext);
